import { nanoid } from "nanoid";
import type { CreateSOPFormDTO } from "@/modules/sop/domain/contracts";

export const sopFormSamples: CreateSOPFormDTO[] = [
  {
    title: "ຂັ້ນຕອນການຈັດການລູກຄ້າ",
    purpose: "ເພື່ອກໍານົດຂັ້ນຕອນການຕອບສະໜອງລູກຄ້າຢ່າງມາດຕະຖານ ແລະ ເປັນລະບົບ",
    scope: "SOP ນີ້ໃຊ້ສໍາລັບທຸກພະແນກທີ່ມີການຕິດຕໍ່ກັບລູກຄ້າ",
    departmentId: null,
    responsiblePersonId: null,
    positionIds: [],
    steps: [
      {
        id: nanoid(),
        stepNumber: 1,
        title: "ຕົບຮັບລູກຄ້າ",
        responsibleId: null,
        notes: "ຕ້ອງຕົບຮັບດ້ວຍຄວາມເອື່ອຍແອບ",
      },
      {
        id: nanoid(),
        stepNumber: 2,
        title: "ສໍາຫຼວດຄວາມຕ້ອງການ",
        responsibleId: null,
        notes: "ຟັງລູກຄ້າຢ່າງລະມັດລະວັງ",
      },
      {
        id: nanoid(),
        stepNumber: 3,
        title: "ແນະນໍາຜົນການແກ້ໄຂ",
        responsibleId: null,
        notes: null,
      },
      {
        id: nanoid(),
        stepNumber: 4,
        title: "ສະໝັກການບໍລິການ",
        responsibleId: null,
        notes: "ອະທິບາຍລາຍລະອຽດຢ່າງຊັດເຈນ",
      },
    ],
    documents: [],
    warnings: ["ຕ້ອງຮັກສາຄວາມລັບຂອງລູກຄ້າ", "ບໍ່ຄວນສັນຍາສິ່ງທີ່ບໍ່ສາມາດຈັດສົ່ງໄດ້"],
    status: "draft",
  },
  {
    title: "ຂັ້ນຕອນການບໍລິການຫຼັງຂາຍ",
    purpose: "ເພື່ອຮັບປະກັນຄຸນນະພາບການບໍລິການຫຼັງຂາຍ",
    scope: "ໃຊ້ສໍາລັບທຸກການຂາຍທີ່ມີການຮັບປະກັນ",
    departmentId: null,
    responsiblePersonId: null,
    positionIds: [],
    steps: [
      {
        id: nanoid(),
        stepNumber: 1,
        title: "ກວດສອບສິນຄ້າ",
        responsibleId: null,
        notes: "ກວດສອບຄຸນນະພາບກ່ອນຈັດສົ່ງ",
      },
      {
        id: nanoid(),
        stepNumber: 2,
        title: "ຈັດສົ່ງສິນຄ້າ",
        responsibleId: null,
        notes: null,
      },
      {
        id: nanoid(),
        stepNumber: 3,
        title: "ຕິດຕາມສະຖານະ",
        responsibleId: null,
        notes: "ແຈ້ງໃຫ້ລູກຄ້າຮູ້ສະຖານະການຈັດສົ່ງ",
      },
      {
        id: nanoid(),
        stepNumber: 4,
        title: "ຢືນຢັນການຮັບສິນຄ້າ",
        responsibleId: null,
        notes: null,
      },
      {
        id: nanoid(),
        stepNumber: 5,
        title: "ສໍາຫຼວດຄວາມພໍໃຈ",
        responsibleId: null,
        notes: "ສົ່ງແບບສໍາຫຼວດຫຼັງຈັດສົ່ງ 3 ວັນ",
      },
    ],
    documents: [],
    warnings: ["ຕ້ອງຈັດສົ່ງຕາມເວລາທີ່ກໍານົດ", "ຖ້າມີບັນຫາໃຫ້ແຈ້ງທັນທີ"],
    status: "active",
  },
  {
    title: "ຂັ້ນຕອນການຈ່າຍເງິນເດືອນ",
    purpose: "ເພື່ອຮັບປະກັນການຈ່າຍເງິນເດືອນຖືກຕ້ອງ ແລະ ທັນເວລາ",
    scope: "ໃຊ້ສໍາລັບພະແນກ HR ແລະ ການເງິນ",
    departmentId: null,
    responsiblePersonId: null,
    positionIds: [],
    steps: [
      {
        id: nanoid(),
        stepNumber: 1,
        title: "ລວບລວມຂໍ້ມູນພະນັກງານ",
        responsibleId: null,
        notes: "ກວດສອບຈໍານວນວັນເຮັດວຽກ",
      },
      {
        id: nanoid(),
        stepNumber: 2,
        title: "ຄິດໄລ່ເງິນເດືອນ",
        responsibleId: null,
        notes: "ລວມ OT, ລາພັກ, ແລະ ລາຍການອື່ນໆ",
      },
      {
        id: nanoid(),
        stepNumber: 3,
        title: "ກວດສອບຄວາມຖືກຕ້ອງ",
        responsibleId: null,
        notes: "ຕ້ອງມີການອະນຸມັດຈາກຜູ້ບໍລິຫານ",
      },
      {
        id: nanoid(),
        stepNumber: 4,
        title: "ຈ່າຍເງິນ",
        responsibleId: null,
        notes: "ຈ່າຍກ່ອນວັນທີ 5 ຂອງເດືອນຖັດໄປ",
      },
    ],
    documents: [],
    warnings: ["ຕ້ອງຮັກສາຄວາມລັບຂອງຂໍ້ມູນເງິນເດືອນ", "ຖ້າມີຂໍ້ຜິດພາດໃຫ້ແກ້ໄຂທັນທີ"],
    status: "active",
  },
  {
    title: "ຂັ້ນຕອນການຮັບສິນຄ້າເຂົ້າຄັງ",
    purpose: "ເພື່ອຮັບປະກັນການຮັບສິນຄ້າເຂົ້າຄັງຖືກຕ້ອງ ແລະ ມີການບັນທຶກ",
    scope: "ໃຊ້ສໍາລັບພະແນກຄັງ ແລະ ການຊື້",
    departmentId: null,
    responsiblePersonId: null,
    positionIds: [],
    steps: [
      {
        id: nanoid(),
        stepNumber: 1,
        title: "ກວດສອບໃບບິນ",
        responsibleId: null,
        notes: "ຕົກລົງກັບໃບບິນຈາກຜູ້ສະໜອງ",
      },
      {
        id: nanoid(),
        stepNumber: 2,
        title: "ນັບຈໍານວນສິນຄ້າ",
        responsibleId: null,
        notes: "ຕ້ອງນັບຢ່າງລະມັດລະວັງ",
      },
      {
        id: nanoid(),
        stepNumber: 3,
        title: "ກວດສອບຄຸນນະພາບ",
        responsibleId: null,
        notes: "ຖ້າມີບັນຫາໃຫ້ແຈ້ງທັນທີ",
      },
      {
        id: nanoid(),
        stepNumber: 4,
        title: "ບັນທຶກເຂົ້າລະບົບ",
        responsibleId: null,
        notes: "ອັບເດດສະຕ໋ອກໃນລະບົບ",
      },
      {
        id: nanoid(),
        stepNumber: 5,
        title: "ເກັບຮັກສາ",
        responsibleId: null,
        notes: "ເກັບຮັກສາໃນບໍລິເວນທີ່ກໍານົດ",
      },
    ],
    documents: [],
    warnings: ["ຕ້ອງກວດສອບກ່ອນຮັບເຂົ້າຄັງ", "ຖ້າສິນຄ້າບໍ່ຕົກລົງກັບໃບບິນໃຫ້ປະຕິເສດ"],
    status: "draft",
  },
  {
    title: "ຂັ້ນຕອນການຈັດການການປະຊຸມ",
    purpose: "ເພື່ອຮັບປະກັນການຈັດການປະຊຸມມີປະສິດທິພາບ",
    scope: "ໃຊ້ສໍາລັບທຸກປະຊຸມພາຍໃນອົງກອນ",
    departmentId: null,
    responsiblePersonId: null,
    positionIds: [],
    steps: [
      {
        id: nanoid(),
        stepNumber: 1,
        title: "ກໍານົດວັນທີ ແລະ ເວລາ",
        responsibleId: null,
        notes: "ປຶກສາຫາລືກັບຜູ້ເຂົ້າຮ່ວມ",
      },
      {
        id: nanoid(),
        stepNumber: 2,
        title: "ສົ່ງເຊີນ",
        responsibleId: null,
        notes: "ສົ່ງກ່ອນປະຊຸມ 3 ວັນ",
      },
      {
        id: nanoid(),
        stepNumber: 3,
        title: "ກະກຽມຫ້ອງປະຊຸມ",
        responsibleId: null,
        notes: "ກວດສອບອຸປະກອນ ແລະ ເຄື່ອງມື",
      },
      {
        id: nanoid(),
        stepNumber: 4,
        title: "ຈັດປະຊຸມ",
        responsibleId: null,
        notes: "ບັນທຶກບັນທັດຖານ",
      },
      {
        id: nanoid(),
        stepNumber: 5,
        title: "ສົ່ງບັນທັດຖານ",
        responsibleId: null,
        notes: "ສົ່ງພາຍໃນ 24 ຊົ່ວໂມງຫຼັງປະຊຸມ",
      },
    ],
    documents: [],
    warnings: ["ຕ້ອງສົ່ງເຊີນລ່ວງໜ້າ", "ຕ້ອງບັນທຶກບັນທັດຖານຢ່າງຊັດເຈນ"],
    status: "active",
  },
];
